var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExclamationError = function SvgExclamationError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4001 6.99998C13.4001 10.5346 10.5347 13.4 7.0001 13.4C3.46548 13.4 0.600098 10.5346 0.600098 6.99998C0.600098 3.46535 3.46548 0.599976 7.0001 0.599976C10.5347 0.599976 13.4001 3.46535 13.4001 6.99998ZM7.8001 10.2C7.8001 10.6418 7.44193 11 7.0001 11C6.55827 11 6.2001 10.6418 6.2001 10.2C6.2001 9.75815 6.55827 9.39998 7.0001 9.39998C7.44193 9.39998 7.8001 9.75815 7.8001 10.2ZM7.0001 2.99998C6.55827 2.99998 6.2001 3.35815 6.2001 3.79998V6.99998C6.2001 7.4418 6.55827 7.79998 7.0001 7.79998C7.44193 7.79998 7.8001 7.4418 7.8001 6.99998V3.79998C7.8001 3.35815 7.44193 2.99998 7.0001 2.99998Z",
    fill: "#D95858"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExclamationError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exclamation-error.c50e903b.svg";
export { ForwardRef as ReactComponent };